import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production'
   ? 'https://api.maisapoio.com.br:3333'
   : 'http://localhost:3333';

const api = axios.create({
   baseURL
});

export default api;
